import { Link, Navigate, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { ScreenTransition } from '@/components/ScreenTransition'
import { ProgressBar } from '@/components/ProgressBar'
import { PainCard } from '@/components/PainCard'
import { PAIN_POINTS } from '@/data/painPoints'
import { PAIN_SCREEN_QUOTE } from '@/data/quotes'
import { useQuiz } from '@/state/QuizContext'
import { pingScreen } from '@/lib/ping'

/**
 * Screen 2 - Pain points. Multi-select card grid.
 *
 * Validation: at least 1 selection required before Next is enabled.
 * "None of the above" is a valid single selection and is mutually exclusive
 * with the other 9 cards (handled by the context toggler).
 *
 * Gate: requires activity already answered.
 */
export function PainScreen() {
  const { activity, painPoints, togglePainPoint } = useQuiz()
  const navigate = useNavigate()

  useEffect(() => { pingScreen('pain') }, [])

  if (!activity) return <Navigate to="/questions/1" replace />

  const canContinue = painPoints.length > 0

  function handleNext() {
    if (!canContinue) return
    navigate('/questions/3')
  }

  return (
    <ScreenTransition className="fq-question">
      <div className="fq-q-inner">
        <ProgressBar current={2} total={4} />

        <header className="fq-q-header">
          <p className="fq-eyebrow">Question 2 of 4</p>
          <h2 className="fq-h2">What's been your biggest struggle with <span className="fq-accent">snow pants?</span></h2>
          <p className="fq-lede">Select all that apply.</p>
        </header>

        <div
          className="fq-pain-grid"
          role="group"
          aria-label="Pain points (select all that apply)"
        >
          {PAIN_POINTS.map((option) => (
            <PainCard
              key={option.id}
              option={option}
              selected={painPoints.includes(option.id)}
              onToggle={() => togglePainPoint(option.id)}
            />
          ))}
        </div>

        <div className="fq-quote-row">
          <figure className="fq-quote">
            <blockquote>"{PAIN_SCREEN_QUOTE.text}" <span className="fq-quote-attr">- {PAIN_SCREEN_QUOTE.attribution}</span></blockquote>
          </figure>
          <div className="fq-actions">
            <Link to="/questions/1" className="fq-back">Back</Link>
            <button
              type="button"
              className="fq-cta"
              onClick={handleNext}
              disabled={!canContinue}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </ScreenTransition>
  )
}
